const indexData = [
  { title: '娱乐圈爆料专区', desc: '明星恋情、片场内幕、综艺翻车等娱乐八卦一网打尽', icon: 'ri-movie-2-fill', count: '1.2万条' },
  { title: '网红圈吃瓜现场', desc: '头部主播、短视频达人翻车事件与行业内幕实时追踪', icon: 'ri-live-fill', count: '9.6千条' },
  { title: '商业圈内幕揭秘', desc: '品牌代言纠纷、企业高管八卦、资本市场瓜田深度解读', icon: 'ri-building-2-fill', count: '7.8千条' },
  { title: '今日黑料速递', desc: '每日最新爆料汇总，不错过任何一个刚出锅的热乎大瓜', icon: 'ri-flashlight-fill', count: '5.4千条' },
  { title: '瓜田爆料合集', desc: '按时间线梳理完整爆料始末，从起因到反转全过程一览无余', icon: 'ri-timeline-view', count: '4.9千条' },
  { title: '黑料视频专区', desc: '热门吃瓜视频、直播录屏、独家采访等多媒体内容聚合', icon: 'ri-video-fill', count: '3.7千条' },
  { title: '饭圈动态观察', desc: '粉圈互撕、站姐脱粉、后援会内斗等饭圈一手资讯', icon: 'ri-heart-pulse-fill', count: '3.2千条' },
  { title: '吃瓜历史档案', desc: '历年经典大瓜回顾，那些年我们一起追过的轰动性事件', icon: 'ri-archive-fill', count: '2.8千条' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            八大内容板块，精准定位你感兴趣的瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="bg-background-50 rounded-xl p-5 hover:bg-background-200 transition-colors duration-200 cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {item.desc}
              </p>
              <span className="text-xs text-accent-600 font-medium">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}